import { ACCOUNTING_URL, JSONAPI_URL } from "../../../services/common-urls";
import { HttpClient, MHTTPCL, JSON_STRING, createHttpGetOptions, jsonToFormData } from "../../../services/http/http-client";
export const DISTRIBUTION_URL = '/distribution.pl';
const ACCOUNTS = 'accounts'

const RELATION = 'relation';
const MODIFICATION_URL = '/modify.pl'
const CONTACT_URL = '/contacts.pl'
export const AccountService = {
  getAccountList: () => HttpClient.get(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: "dis_accounts_tab_accounts_list",
    rndval: "1573822200759",
    output: "json",
  }),
  getNewAccountFormData: () => HttpClient.get(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: "new_account_form",
    rndval: "1582389432828",
    output: "json",
  }),
  getAccountTypeList: (serachText) => HttpClient.get(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: "account_type_autocom_list",
    term: serachText,
    output: "json",
  }),
  getAccounts: (offset) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: "get_accounts",
    offset: offset,
    output: "json"
  }),



  getFilteredAccountList: (searchString = "", channel = "", accountTypes = "") => HttpClient.get(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: "filter_accounts",
    account_name: searchString,
    channel: channel,
    account_types: accountTypes,
    output: "json",
  }),
  filterAccountByChannel: ({
    value, channel = ""
  }) => HttpClient.get(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: "filter_accounts",
    account_name: value,
    channel: channel,
    output: "json",
  }),
  deleteAccount: (accountId) => HttpClient.post(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: 'remove_account',
    account_id: accountId
  }),
  deleteAccountDiscount: ({
    account_pricecode_id
  }) => HttpClient.post(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: 'remove_account_pricecode',
    account_pricecode_id: account_pricecode_id
  }),
  deleteAccountRelation: ({
    relation_id
  }) => HttpClient.post(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: 'remove_manual_match',
    relation_id: relation_id
  }),

  deleteLabelAccount: ({
    label_account_id
  }) => HttpClient.post(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: 'remove_label_account',
    label_account_id: label_account_id
  }),
  deleteProductAccount: ({
    product_account_id
  }) => HttpClient.post(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: 'remove_product_account',
    product_account_id: product_account_id
  }),

  deleteCurrentStatement: ({
    statement_id
  }) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: 'remove_cur_sttmnt',
    statement_id: statement_id
  }),
  deleteStatementSetting: ({
    statement_setting_id
  }) => HttpClient.post(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: 'remove_stmt_setting',
    statement_setting_id: statement_setting_id
  }),
  deleteOrderItem: ({
    statement_setting_id
  }) => HttpClient.post(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: 'remove_stmt_setting',
    statement_setting_id: statement_setting_id
  }),

  deleteBackorder: ({
    backorder_id
  }) => HttpClient.post(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: 'remove_account_backorder',
    backorder_id
  }),


  addAccount: (account) => HttpClient.post(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: 'add_account',
    ...account
  }),

  getAccountTabOverview: (account_id) => HttpClient.get(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: "account_details_tab_overview",
    account_id: account_id,
    output: "json",
  }),
  getAccountTabSetup: (account_id) => HttpClient.get(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: "account_details_tab_setup",
    account_id: account_id,
    output: "json",
  }),
  getAccountTabCatalogue: (account_id) => HttpClient.get(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: "account_details_tab_catalogue",
    account_id: account_id,
    output: "json",
  }),
  getAccountTabCatalogue: (account_id) => HttpClient.get(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: "account_details_tab_catalogue",
    account_id: account_id,
    output: "json",
  }),
  getAccountTabOrders: (account_id) => HttpClient.get(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: "account_details_tab_orders",
    account_id: account_id,
    output: "json",
  }),
  getAccountTabCurrentStatement: (account_id) => HttpClient.get(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: "account_tab_current_statements",
    account_id: account_id,
    output: "json",
  }).then(res => {
    return {
      ...res,
      data: {
        ...res.data,
        current_statements: res.data.statements,
      }
    };
  }),
  getAccountTabStatementHistory: (account_id) => HttpClient.get(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: "account_details_tab_statements_history",
    account_id: account_id,
    output: "json",
  }),
  getAccountTabCOST: (account_id) => HttpClient.get(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: "account_details_tab_invoice_costs",
    account_id: account_id,
    output: "json",
  }),
  getLabelAccount: ({ account_id }) => HttpClient.get(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: "add_label_account_form",
    account_id,
    output: "json",
  }),
  findLabelAccount: ({ account_id, label_name }) => HttpClient.post(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: "find_account_unrelated_labels",
    account_id: account_id,
    label_name: label_name,
    dofind: 'yes',
    output: "json",
  }),

  addNewLabelAccount: ({ account_id, label_name = "" }) => HttpClient.get(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: "add_new_label_label_account",
    account_id: account_id,
    label_name: label_name,
    output: "json",
  }),
  insertLabelAccount: ({ account_id, label_id }) => HttpClient.get(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: "add_account_label_account",
    account_id: account_id,
    label_id: label_id,
    output: "json",
  }),

  getProductAccount: (account_id) => HttpClient.get(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: "add_product_account_form",
    account_id: account_id,
    output: "json",
  }),
  insertProductAccount: ({ account_id, productIds }) => HttpClient.get(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: "add_account_product_account",
    account_id: account_id,
    products: productIds,
    output: "json",
  }),
  findAccountUnrelatedProducts: ({ account_id, catalog_no }) => HttpClient.get(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: "find_account_unrelated_products",
    account_id: account_id,
    catalog_no: catalog_no,
    dofind: 'yes',
    output: "json",
  }),


  getOrderAccount: ({ account_id }) => HttpClient.get(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: "account_order_form",
    account_id: account_id,
    output: "json",
  }),
  insertOrder: ({ account_id, order_reference, order_type, contra_account_id }) => HttpClient.get(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: "add_order",
    account_id: account_id,
    order_reference: order_reference,
    order_type: order_type,
    contra_account_id: contra_account_id,
    output: "json",
  }),

  getNewStatement: ({ account_id }) => HttpClient.get(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: "new_cur_sttmnt_form",
    account_id: account_id,
    output: "json",
  }),


  insertCurrentStatement: ({ account_id, digital_physical, statement_year, statement_period_txt, currency_id, invoice_project_id }) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: "add_cur_sttmnt",
    account_id: account_id,
    digital_physical: digital_physical,
    statement_year: statement_year,
    statement_period_txt: statement_period_txt,
    currency_id: currency_id,
    invoice_project_id: invoice_project_id,
    output: "json",
  }),
  getAccountStatement: () => HttpClient.get(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: "account_statememnt_setup_form1",
    output: "json",
  }),
  displayPaypalPaymentMsgModal: (invoice_id) => HttpClient.get(ACCOUNTING_URL, {
    section: 'invoices',
    action: "displayPaypalPaymentMsgModal",
    invoice_id: invoice_id,
    output: "json",
  }),
  emailInvoiceDetails: (invoice_id) => HttpClient.get(ACCOUNTING_URL, {
    section: 'invoice_reminder',
    action: "emailInvoiceDetails",
    invoice_id: invoice_id,
    output: "json",
  }),


  insertAccountStatement: ({ account_id, description, invoice_project_id, digital_physical, statement_period, fix_country, start_date, end_date, dss_id, sender, shared_key, contact_id_invoice, currency_id }) => HttpClient.get(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    account_id: account_id,
    description: description,
    invoice_project_id: invoice_project_id,
    digital_physical: digital_physical,
    statement_period: statement_period,
    fix_country: fix_country,
    start_date: start_date,
    end_date: end_date,
    dss_id: dss_id,
    sender: sender,
    shared_key: shared_key,
    contact_id_invoice: contact_id_invoice,
    currency_id: currency_id,
    action: 'new_edit_stmt_settings',
    output: "json",
  }),

  modifyRelatedContactRelation: ({
    contactRelationId,
    value
  }) => modifyRelatedContact({
    kVal: contactRelationId,
    name: RELATION,
    value
  }),

  modifyAccount: ({
    accountId,
    name,
    value
  }) => HttpClient.post(MODIFICATION_URL, {
    kVal: accountId,
    name: name,
    value: value,
    table: 'l_accounts',
  }),
  modify: ({ table, kVal, name, value }) => MHTTPCL.post(MODIFICATION_URL, {
    table,
    kVal,
    name,
    value,
    output: JSON_STRING
  }),
  insertContactInvoice: (
    { accountId,
      contactId
    }
  ) => HttpClient.post(CONTACT_URL, {
    action: 'set_item_contact',
    table: 'l_accounts',
    key: 'account_id',
    kVal: accountId,
    name: 'contact_id_invoice',
    value: contactId,
    template_type: 'standard',
    contact_search_type: 'both',
    output: "json"
  }),
  insertContactDelivery: (
    { accountId,
      contactId
    }
  ) => HttpClient.post(CONTACT_URL, {
    action: 'set_item_contact',
    table: 'l_accounts',
    key: 'account_id',
    kVal: accountId,
    name: 'contact_id_delivery',
    value: contactId,
    template_type: 'standard',
    contact_search_type: 'both',
    output: "json"
  }),

  insertDiscount: (
    { key,
      kVal,
      name,
      value
    }
  ) => HttpClient.post(MODIFICATION_URL, {
    table: 'l_account_pricecodes',
    key: key,
    kVal: kVal,
    name: name,
    value: value,
    output: "json"
  }),
  insertLabel: (
    { key,
      kVal,
      name,
      value,
      table
    }
  ) => HttpClient.post(MODIFICATION_URL, {
    table: table,
    key: key,
    kVal: kVal,
    name: name,
    value: value,
    output: "json"
  }),


  addDiscountPricecode: ({ account_id }) => HttpClient.post(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: 'add_discount_pricecode_name',
    account_id: account_id,
    discount: 0,
    price_code_name: "",
    output: "json"
  }),



  getExportAccountBackOrder: (accountId) => HttpClient.postJSONasFormData(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: 'export_account_backorders',
    account_id: accountId,
    output: "json"
  }, createHttpGetOptions({ responseType: 'blob' })),
  getExportAccountHistory: (accountId) => HttpClient.postJSONasFormData(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: 'export_acc_stmt_history',
    account_id: accountId,
  }, createHttpGetOptions({ responseType: 'blob' })),

  //overview
  deleteRelation: (contact_relation_id) => MHTTPCL.post(CONTACT_URL, {
    action: "delete_relation",
    contact_relation_id: contact_relation_id
  }),

  displayPaypalPaymentMsgModal: ({ invoice_id }) => MHTTPCL.post(ACCOUNTING_URL, {
    section: "invoices",
    action: "displayPaypalPaymentMsgModal",
    invoice_id: invoice_id
  }),

  emailInvoiceDetails: (invoice_id) => MHTTPCL.post(ACCOUNTING_URL, {
    section: 'invoice_reminder',
    action: 'emailInvoiceDetails',
    invoice_id: invoice_id,
    output_media: ''
  }),

  includePaypalOption: (invoice_id) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: 'invoices',
    action: 'includePaypalOption',
    invoice_id: invoice_id
  }),

  createSetStatementsInvoice: (account_id, statements, royalty_date1) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "accounts",
    action: "create_set_statements_invoice",
    account_id: account_id,
    statements: JSON.stringify(statements),
    royalty_date1: royalty_date1
  }),

  createBigStatementsSales: (account_id, statements, royalty_date1) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: 'accounts',
    action: 'create_big_statements_sales',
    account_id: account_id,
    statements: JSON.stringify(statements),
    royalty_date1: royalty_date1,
  }),


  setAccountonMultipleInvoice: (account_id, statement_ids) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "accounts",
    action: "account_on_multiple_invoice",
    account_id: account_id,
    statement_ids: JSON.stringify(statement_ids)
  }),


  //:::::::::::::::::::::::::::::

  accountStatememntSetupForm1: (account_id, statement_setting_id = "") => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "accounts",
    action: "account_statememnt_setup_form1",
    account_id: account_id,
    statement_setting_id: statement_setting_id,
    output: JSON_STRING
  }),

  channelPresets: (channel) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "statementsin",
    action: "channel_presets",
    channel: channel
  }),

  stmtInvoiceContactList: (start = undefined) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "accounts",
    action: "stmt_invoice_contact_list",
    start: start
  }),

  searchStmtInvoiceContactList: (search) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "accounts",
    action: "search_stmt_invoice_contact_list",
    search: search
  }),

  getContact: (contact_id) => MHTTPCL.post(JSONAPI_URL, {
    action: "get_contact",
    contact_id: contact_id,
    output: JSON_STRING
  }),

  newEditStmtSettings: (payload) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "accounts",
    action: "new_edit_stmt_settings",
    ...payload

  }),

  accountStmtSettingsList: (account_id) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "accounts",
    action: "account_stmt_settings_list",
    account_id: account_id
  }),

  addCurSttmnt: ({ account_id, statement_year, statement_period_txt, statement_setting_id }) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: ACCOUNTS,
    action: "add_cur_sttmnt",
    account_id: account_id,
    statement_year: statement_year,
    statement_period_txt: statement_period_txt,
    statement_setting_id: statement_setting_id,
    output: "json",
  }),


  /**
 * Sends a POST request to check the royalty period for the given statement IDs.
 *
 * @param {Array<number>} statement_ids - The IDs of the statements to check.
 * @returns {Promise<{sales_date_smaller: boolean, sales_date: string, royalty_date: string}>} A promise that resolves to an object with the properties `sales_date_smaller`, `sales_date`, and `royalty_date`.
 */
  check_royalty_period: (statement_ids) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "accounts",
    action: "check_royalty_period",
    statement_ids: JSON.stringify(statement_ids)
  }).then(res => {
    return res.data;
  }),


/**
 * Sends a POST request to check the royalty period for the given statement IDs.
 *
 * @param {Array<number>} statement_ids - The IDs of the statements to check.
 * @returns {Promise<{sales_date_smaller: boolean, sales_date: string, royalty_date: string}>} A promise that resolves to an object with the properties `sales_date_smaller`, `sales_date`, and `royalty_date`.
 */

  amazonDssData:(statement_setting_id)=>MHTTPCL.post(DISTRIBUTION_URL,{
    section:	ACCOUNTS,
    action	:"amazon_dss_data",
    statement_setting_id:statement_setting_id,
    output:JSON_STRING
  }),
  merlinAutoImport: (payload, domain_tld) => HttpLib.post(`https://batch.${domain_tld}/${MHTTPCL.clientName}${DISTRIBUTION_URL}`, querystring.stringify({
    section	:ACCOUNTS,
    action	:"merlin_auto_import",
    ...payload

  },
    { arrayFormat: 'brackets' }),
    { withCredentials: true }
  ),
  // merlinAutoImport:()=>MHTTPCL.post(DISTRIBUTION_URL,{
  //   section	"accounts"
  //   action	"merlin_auto_import"
  //   statement_setting_id	"2165"
  //   statement_year	"2024"
  //   statement_period_txt	"M1"
  //   merlin	"flo-flo"
  // })


  





  //digital
  //   account_id	"249"
  // description	"11"
  // invoice_project_id	"101"
  // digital_physical	"digital"
  // statement_period	"monthly"
  // fix_country	""
  // start_date	""
  // end_date	""
  // dss_id	""
  // sender	""
  // shared_key	""
  // statement_preset_id	""
  // currency_id	"5"
  // fix_shop	"A1KA"
  // fix_digital_type	""
  // distribution_fee_sales	""
  // distribution_fee_returns	""
  // contact_id_invoice	"27319"

  //physical

  // account_id	"249"
  // description	"11"
  // invoice_project_id	"101"
  // digital_physical	"physical"
  // statement_period	"monthly"
  // fix_country	""
  // start_date	""
  // end_date	""
  // dss_id	""
  // sender	""
  // shared_key	""
  // statement_preset_id	""
  // currency_id	"5"
  // return_handling_fee	""
  // distribution_fee_sales	""
  // distribution_fee_returns	""
  // contact_id_invoice	"27319"

  //cost


  // account_id	"249"
  // description	"11"
  // invoice_project_id	"101"
  // digital_physical	"costs"
  // statement_period	"monthly"
  // fix_country	""
  // start_date	""
  // end_date	""
  // dss_id	""
  // sender	""
  // shared_key	""
  // statement_preset_id	""
  // contact_id_invoice	"27319"


  //thirdparty
  // account_id	"249"
  // description	"11"
  // invoice_project_id	"101"
  // digital_physical	"thirdparty"
  // statement_period	"monthly"
  // fix_country	""
  // start_date	""
  // end_date	""
  // dss_id	""
  // sender	""
  // shared_key	""
  // statement_preset_id	""
  // currency_id	"5"
  // fix_digital_type	""
  // distribution_fee_sales	""
  // distribution_fee_returns	""
  // contact_id_invoice	"27319"

  //performance
  // account_id	"249"
  // description	"11"
  // invoice_project_id	"101"
  // digital_physical	"performance"
  // statement_period	"monthly"
  // fix_country	""
  // start_date	""
  // end_date	""
  // dss_id	""
  // sender	""
  // shared_key	""
  // statement_preset_id	""
  // currency_id	"5"
  // fix_digital_type	""
  // distribution_fee_sales	""
  // distribution_fee_returns	""
  // contact_id_invoice	"undefined"


  //income
  // account_id	"249"
  // description	"11"
  // invoice_project_id	"101"
  // digital_physical	"income"
  // statement_period	"quarterly"
  // fix_country	""
  // start_date	""
  // end_date	""
  // dss_id	""
  // sender	""
  // shared_key	""
  // statement_preset_id	""
  // contact_id_invoice	"undefined"

  //multi

  // account_id	"249"
  // description	"11"
  // invoice_project_id	"101"
  // digital_physical	"multi"
  // statement_period	"monthly"
  // fix_country	""
  // start_date	""
  // end_date	""
  // dss_id	""
  // sender	""
  // shared_key	""
  // statement_preset_id	""
  // currency_id	"5"
  // fix_shop	"A1KA"
  // fix_digital_type	""
  // distribution_fee_sales	""
  // distribution_fee_returns	""
  // contact_id_invoice	"27319"




}